import React, { Component } from 'react';
import { Collapse, Container, Navbar, NavbarBrand, NavbarToggler, Button } from 'reactstrap';
import { Link, withRouter  } from 'react-router-dom';
import { LoginMenu } from './api-authorization/LoginMenu';
import '../styles/NavMenu.css'
import AuthFunctions from './services/AuthService';
import q4Logo from '../images/PsychAssoc_logo_full_alt.png';
//import q4Logo from '../images/image002.png';

class NavMenu extends Component {
    static displayName = NavMenu.name;

    constructor(props) {
        super(props);

        this.toggleNavbar = this.toggleNavbar.bind(this);
        this.state = {
            collapsed: true,
            currentUrl: null,
            hideButton: true
        };
        this.populateState();
    }

    toggleNavbar() {
        this.setState({
            collapsed: !this.state.collapsed
        });
    }
    componentDidUpdate(prevProps) {
        if (this.props.location.pathname !== prevProps.location.pathname) {
            this.populateState();
        }
    }

    componentDidMount() {
        this.populateState();
    }

    async populateState() {
        //const [isAuthenticated, user] = await Promise.all([authService.isAuthenticated(), authService.getUser()])
        const isAuthenticated = await this.checkAuthenticated();
        var currentUrl = window.location.href;
        var hideButton = !isAuthenticated;
        //var currentUrl = window.location.href;
        if (currentUrl.includes("FAQ") || this.state.anonymousView === true) {
            hideButton = true;
        }
        this.setState({ authenticated: isAuthenticated });
        this.setState({ currentUrl: currentUrl });
        this.setState({ hideButton: hideButton });
    }

    async checkAuthenticated() {
        var isAuthenticated = await AuthFunctions.getAuthenticatedAsync();
        return isAuthenticated;
    }

    gotoFAQ() {
        window.location.href = '/FAQ';
    }
    render() {
        
        return (
            <header>
                <Navbar className="navbar-expand-sm navbar-toggleable-sm ng-white mb-3" light>
                    <Container>
                        <NavbarBrand tag={Link} to="/">
                            <img src={q4Logo} style={{ width: '230px' }} alt={''} />
                        </NavbarBrand>
                        <NavbarToggler onClick={this.toggleNavbar} className="mr-2" />
                        <Collapse className="d-sm-inline-flex flex-sm-row-reverse" isOpen={!this.state.collapsed} navbar>
                            <div>
                                <div>
                                    <ul className="navbar-nav flex-grow">
                                        {/* <NavItem>
                                  <NavLink tag={Link} className="text-dark" to="/">Home</NavLink>
                                </NavItem> */}
                                        {/* <NavItem>
                                  <NavLink tag={Link} className="text-dark" to="/counter">Counter</NavLink>
                                </NavItem>
                                <NavItem>
                                  <NavLink tag={Link} className="text-dark" to="/fetch-data">Fetch data</NavLink>
                                </NavItem> */}
                                        <LoginMenu>
                                        </LoginMenu>
                                    </ul>
                                </div>
                                {!this.state.hideButton  && (
                                    <div style={{ textAlign: 'right' }} className="helpButton">
                                        <span style={{ marginLeft: '.5rem' }}>
                                            <Button
                                                color='primary'
                                                onClick={() => this.gotoFAQ()}
                                                style={{ padding: '2px' }}
                                            >
                                                Help
                                            </Button>                                    </span>
                                    </div>
                                )}
                                
                            </div>
                        </Collapse>
                    </Container>
                </Navbar>
            </header>
        );
    }
}

export default withRouter(NavMenu);